module.exports = __webpack_public_path__ + "assets/media/day5.822c90b6.mp3";